
<span :class="`article-tag-wrapper ${tagColor}`"><slot /></span>
